import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import BostonMarathon from './BostonMarathon.jsx';
import RoadClosures from './RoadClosures.jsx';
import { bostonRoute } from '../geojson/racePaths.js';
import MileMarkers from '../geojson/MileMarkers';
import KmMarkers from '../geojson/KmMarkers';
import HydrationStations from '../geojson/HydrationStations';
import CliffZones from '../geojson/CliffZones';
import MedicalStations from '../geojson/MedicalStations';
import Toilets from '../geojson/Toilets';
import TStations from '../geojson/TStations';

import {
  getAccessToken,
  getStyle,
} from '../helpers/helpers.js';

export default class BostonMapbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
    }
  }

  componentDidMount () {
    mapboxgl.accessToken = getAccessToken();

    const maxBounds = [
      [-71.76294140674246, 41.9646506826499], // Southwest coordinates
      [-70.77900356067529, 42.60030513514329]  // Northeast coordinates
    ];

    let map = new mapboxgl.Map({
      // container id
      container: 'map',
      // style location
      style: getStyle('streets'),
      // starting position
      center: [-71.301182881936, 42.297347071405994],
      zoom: 11,
      maxBounds: maxBounds,
    });
    this.setState({
      map: map
    });
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    map.doubleClickZoom.enable();

    var coordinates = bostonRoute.data.geometry.coordinates;
    var bounds = coordinates.reduce(function(bounds, coord) {
        return bounds.extend(coord);
    }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

    map.fitBounds(bounds, {
        padding: 100
    });

    map.on('click', function (e) {
      console.log(e.lngLat);
    });

    map.on('load', function () {

      map.addSource("route", bostonRoute);

      map.addLayer({
        "id": "route",
        "type": "line",
        "source": "route",
        "layout": {
            "line-join": "round",
            "line-cap": "round"
        },
        "paint": {
            "line-color": "#1C3667",
            "line-width": {
              "stops": [[10, 14], [20, 25]]
            },
            "line-opacity": 0.6,
        }
      });

      MileMarkers.addMarkers(map);
      KmMarkers.addMarkers(map);
      HydrationStations.addMarkers(map);
      CliffZones.addLines(map);
      MedicalStations.addMarkers(map);
      Toilets.addMarkers(map);
      TStations.addMarkers(map);

      // add half way point
      var el_halfway = document.createElement('div');
        el_halfway.className = 'bold-header';
        el_halfway.style.height = 40 + 'px';
        el_halfway.style.width = 40 + 'px';
        el_halfway.innerText = 'HALF';

      new mapboxgl.Marker(el_halfway, {offset: [-20, 2]})
          .setLngLat([-71.29780678743504, 42.29223245210133])
          .addTo(map);

      map.addSource("halfwayPointer", {
        "type": "geojson",
        "data": {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": [
              [
                -71.29491539999998,
                42.2963239
              ],
              [
                -71.29780678743504,
                42.29223245210133
              ],
            ]
          }
        }
      });

      map.addLayer({
        "id": "halfwayPointer",
        "type": "line",
        "source": "halfwayPointer",
        "layout": {
          "line-join": "round",
          "line-cap": "round"
        },
        "paint": {
          "line-color": "#555",
          "line-width": 3,
          "line-opacity": 0.6,
        }
      });


      let startEl = document.createElement('div');
      startEl.className = 'bold-header';
      startEl.style.height = 40 + 'px';
      startEl.style.width = 40 + 'px';
      startEl.innerText = 'START';

      new mapboxgl.Marker(startEl, {offset: [-40, 10]})
        .setLngLat([-71.51819586753845, 42.229785465624815])
        .addTo(map);

      // map.addSource("startPointer", {
      //   "type": "geojson",
      //   "data": {
      //     "type": "Feature",
      //     "properties": {},
      //     "geometry": {
      //       "type": "LineString",
      //       "coordinates": [
      //         [
      //           -71.51819586753845,
      //           42.229785465624815
      //         ],
      //         [
      //           -71.5220506629831,
      //           42.22842537982214
      //         ],
      //       ]
      //     }
      //   }
      // });
      //
      // map.addLayer({
      //   "id": "startPointer",
      //   "type": "line",
      //   "source": "startPointer",
      //   "layout": {
      //     "line-join": "round",
      //     "line-cap": "round"
      //   },
      //   "paint": {
      //     "line-color": "#555",
      //     "line-width": 3,
      //     "line-opacity": 0.6,
      //   }
      // });


      let finishEl = document.createElement('div');
      finishEl.className = 'bold-header';
      finishEl.style.height = 40 + 'px';
      finishEl.style.width = 40 + 'px';
      finishEl.innerText = 'FINISH';

      new mapboxgl.Marker(finishEl, {offset: [20, 0]})
        .setLngLat([-71.07844813106881, 42.349792930260634])
        .addTo(map);

    //   map.addSource("finishPointer", {
    //     "type": "geojson",
    //     "data": {
    //       "type": "Feature",
    //       "properties": {},
    //       "geometry": {
    //         "type": "LineString",
    //         "coordinates": [
    //           [
    //             -71.07858717441559,
    //             42.34976701008725
    //           ],
    //           [
    //             -71.07844813106881,
    //             42.349792930260634
    //           ],
    //         ]
    //       }
    //     }
    //   });
    //
    //   map.addLayer({
    //     "id": "finishPointer",
    //     "type": "line",
    //     "source": "finishPointer",
    //     "layout": {
    //       "line-join": "round",
    //       "line-cap": "round"
    //     },
    //     "paint": {
    //       "line-color": "#555",
    //       "line-width": 3,
    //       "line-opacity": 0.6,
    //     }
    //   });
    });
  }

  render() {
    return (<div>
      <BostonMarathon map={this.state.map} />
      <RoadClosures map={this.state.map} />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/marathon/BostonMapbox.jsx